import React from "react"
import { Box } from "@mui/material"
import { images } from "utils/images"
import { UILanguageSelector } from "components/UI/LanguageSelector"
import { styles } from "./Header.styles"

export default function Header() {
  return (
    <Box sx={styles.header}>
      <Box
        component="img"
        src={images.logo}
        alt="Smash Education Logo"
        sx={styles.logo}
      />
      <Box>
        <UILanguageSelector />
      </Box>
    </Box>
  )
}
